export default interface Login {
    name: string;
    password: string;
    code: string;
    verificationCode: string;
}

export const loginDefaultProps: Login = {
    name: '',
    password: '',
    code: '',
    verificationCode: '',
}